import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { ConfigService } from '../../core/services/config.service';
import { TranslatePipe } from '../pipes/translate.pipe';

/** Formatted price with a small currency suffix (currency from admin config). */
@Component({
  selector: 'app-price',
  standalone: true,
  imports: [DecimalPipe, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<span class="fr-num"
      [style.color]="color"
      [style.font-weight]="weight"
      [style.font-size.px]="size"
      style="white-space:nowrap;letter-spacing:-0.01em">{{ value | number }}<span
        [style.font-size.px]="size * 0.66"
        [style.opacity]="muted ? 0.6 : 0.78"
        style="font-weight:600;margin-inline-start:3px">{{ currency | t }}</span></span>`,
})
export class PriceComponent {
  @Input() value = 0;
  @Input() size = 15;
  @Input() weight: number | string = 700;
  @Input() color = 'inherit';
  @Input() muted = false;
  /** Optional override; defaults to the configured currency. */
  @Input() ccy?: string;

  constructor(private config: ConfigService) {}

  get currency(): string { return this.ccy ?? this.config.currency; }
}
